import React, { useEffect } from "react";
import { ApprovalsTableContributor, ApprovalsTableAdmin } from "./ApprovalsHelpers";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageWrap from "components/PageWrap/PageWrap";
import LoadResolver from "components/LoadResolver";

export const ApprovalsPageAdmin = (props) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const approvals = useSelector((state) => state.approvals);
  const { items, isLoading } = approvals;

  useEffect(() => {
    dispatch.approvals.load();
  }, []);

  return (
    <PageWrap page="approvals" t={t}>
      <div>
        <Switch>
          <Route
            exact
            path={"/approvals"}
            render={() => (
              <LoadResolver isLoading={isLoading}>
                <ApprovalsAdmin
                  t={t}
                  dispatch={dispatch}
                  approvalsIsLoading={isLoading}
                  approvals={items}
                />
              </LoadResolver>
            )}
          />
        </Switch>
      </div>
    </PageWrap>
  );
};

export const ApprovalsPageContributor = (props) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const approvals = useSelector((state) => state.approvals);
  const { items, isLoading } = approvals;

  useEffect(() => {
    dispatch.approvals.load();
  }, []);

  return (
    <PageWrap page="approvals" t={t}>
      <div>
        <Switch>
          <Route
            exact
            path={"/approvals"}
            render={() => (
              <LoadResolver isLoading={isLoading}>
                <ApprovalsContributor
                  t={t}
                  dispatch={dispatch}
                  approvalsIsLoading={isLoading}
                  approvals={items}
                />
              </LoadResolver>
            )}
          />
        </Switch>
      </div>
    </PageWrap>
  );
};

const ApprovalsAdmin = ({ t, approvals, dispatch }) => {
  if (approvals) {
    return (
      <div>
        <ApprovalsTableAdmin
          t={t}
          data={approvals.filter((item) => !!item && item?.status?.includes("CAP"))}
          dispatch={dispatch}
        />
      </div>
    );
  }
};

const ApprovalsContributor = ({ t, approvals, dispatch }) => {
  if (approvals) {
    return (
      <div>
        <ApprovalsTableContributor
          t={t}
          data={approvals.filter((item) => !!item && item?.status?.includes("CAP"))}
          dispatch={dispatch}
        />
      </div>
    );
  }
};
